import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import "./body.scss";
const addBodyClass = (className) =>
  document.body.classList.add("removeHeaderFooter");
const removeBodyClass = (className) =>
  document.body.classList.remove("removeHeaderFooter");
function InstructionsSent(props) {
  useEffect(() => {
    // Set up
    props.className instanceof Array
      ? props.className.map(addBodyClass)
      : addBodyClass("removeHeaderFooter");

    // Clean up
    return () => {
      props.ArrayclassName instanceof Array
        ? props.className.map(removeBodyClass)
        : removeBodyClass("removeHeaderFooter");
    };
  }, [props.className]);
  return (
    <>
      <div className="inner_main">
        <div className="row  w-100">
          <div className="col-xl-3 d_none_1199"></div>
          <div className="col-xl-6">
            <div className="row">
              <div className="col-md-12 text-center mt-15 mb-10">
                <img
                  alt="Logo"
                  className="max-h-70px mb-5"
                  src={toAbsoluteUrl("/media/logos/auth_logo.png")}
                />
              </div>
              <div className="col-md-12">
                <div className="wt_box wt_box_instctn">
                  <div
                    className="login-form login-forgot"
                    style={{ display: "block" }}
                  >
                    <div className="text-center mb-10 mb-lg-10">
                      <img
                        alt="Logo"
                        className="mb-5 mt-4"
                        src={toAbsoluteUrl("/media/others/instrctns_sntbg.png")}
                      />
                      <h3 className="fn_s_32 color_blk f-w-500 mt-5">
                        Instructions Sent
                      </h3>
                      <p className="opacity60 fn_s_14 color_blk f-w-400">
                        We have sent instructions on username@contact.com.
                        Please check and follow the steps.
                      </p>
                    </div>
                    <form className="form def_form"></form>
                  </div>
                </div>
              </div>
              <div className="col-md-12 text-center mt-10 bottom_links">
                <Link
                  to="/login"
                  className="bckbtn fn_s_14 color_blk f-w-500 opacity50 uppercase"
                >
                  Back To login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InstructionsSent;
